// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullAdminRegattaResultOverall,
  $Model,
  $ModelUpsertParams,
} from 'common.data';

// Global Enums
import {
  RegattaResultOverallFilter,
  RegattaResultOverallType,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';
import {
  InputDoubleButton,
  InputMultiselect,
} from '@vroskus/library-components';

// Helpers
import _ from 'lodash';
import {
  regattaResultOverallFilterLabel,
  regattaResultOverallTypeLabel,
} from 'common.language';

// Types
type $Props = $Translate & {
  item: $FullAdminRegattaResultOverall | ($ModelUpsertParams<'RegattaResultOverall'> & {
    RegattaResultTables: Array<$Model<'RegattaResultTable'>>;
  });
  resourceData: Array<$Model<'RegattaResultTable'>>;
};

const RegattaResultOverallFieldsView = function ({
  item,
  resourceData,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col xs={4}>
          <InputDoubleButton
            label={t('Visibility')}
            labelFalse={t('Hidden')}
            labelTrue={t('Visible')}
            name={'Public'}
            value={item.Public}
          />
        </Col>
        <Col xs={8}>
          <AvField
            label={t('Title')}
            name={'Name'}
            required
            value={item.Name}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Position calculation value')}
            name={'Type'}
            required
            type={'select'}
            value={item.Type}
          >
            {_.map(
              RegattaResultOverallType,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(regattaResultOverallTypeLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
      <Row>
        <Col>
          <InputMultiselect
            label={t('Regatta result tables')}
            labelSelectMultiple={t('Select multiple')}
            name={'RegattaResultTables'}
            options={resourceData}
            required
            value={_.get(
              item,
              'RegattaResultTables',
              [],
            ) as Array<$Model<'RegattaResultTable'>>}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Filter')}
            name={'Filter'}
            type={'select'}
            value={item.Filter}
          >
            <option />
            {_.map(
              RegattaResultOverallFilter,
              (i) => (
                <option
                  key={i}
                  value={i}
                >
                  {t(regattaResultOverallFilterLabel[i])}
                </option>
              ),
            )}
          </AvField>
        </Col>
      </Row>
    </>
  );
};

export default RegattaResultOverallFieldsView;
